import React from "react";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  text?: string;
  fullScreen?: boolean;
}

const sizes: Record<NonNullable<LoadingSpinnerProps["size"]>, string> = {
  sm: "w-4 h-4 border-2",
  md: "w-6 h-6 border-2",
  lg: "w-8 h-8 border-2",
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "md",
  text = "Carregando…",
  fullScreen = false,
}) => {
  const inner = (
    <div
      className="flex flex-col items-center gap-2.5"
      role="status"
      aria-live="polite"
    >
      <div
        aria-hidden="true"
        className={`${sizes[size]} border-border border-t-primary rounded-full animate-spin`}
      />
      {text && <p className="text-xs text-muted-foreground">{text}</p>}
      <span className="sr-only">{text || "Carregando"}</span>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-background/85 flex items-center justify-center z-50">
        {inner}
      </div>
    );
  }

  return <div className="flex items-center justify-center py-12">{inner}</div>;
};

export default LoadingSpinner;
